import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b246707")

_pushScopeId("data-v-0b246707")
const _hoisted_1 = { class: "flex w-full h-full bg-primary-dark-medium" }
const _hoisted_2 = { class: "w-full parent" }
const _hoisted_3 = { class: "border-r grid-chapter-select-sidebar bg-primary-dark-medium-opaque" }
const _hoisted_4 = {
  class: "w-full bg-primary-dark-medium h-18",
  style: {"min-width":"4rem"}
}
const _hoisted_5 = { class: "flex flex-col justify-center h-full pl-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "border-b grid-filter-widget" }
const _hoisted_8 = { class: "border-l grid-recommendation-sidebar bg-primary-dark-medium" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col justify-center pl-6 border-b h-18" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-lg" }, "Recommendations")
], -1)
const _hoisted_10 = { class: "p-5 border-b" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "w-full pb-2 font-light" }, "Top recommendations", -1)
const _hoisted_12 = { class: "p-5" }
const _hoisted_13 = { class: "flex mb-5 text-sm font-light" }
const _hoisted_14 = { class: "flex cursor-pointer" }
const _hoisted_15 = { class: "flex flex-col justify-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ml-2" }, "Expand all", -1)
const _hoisted_17 = { class: "flex ml-6 cursor-pointer" }
const _hoisted_18 = { class: "flex flex-col justify-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "ml-2" }, "Collapse all", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "mb-2" }, "Training Tools", -1)
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "z-0 grid-learning-objective-canvas" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { id: "game" }, null, -1)
_popScopeId()

import { onMounted, onUnmounted, ref } from 'vue';
import Phaser, { Types } from 'phaser';
import { CANVAS, colors, statusFilterOptions } from './constants';
import StudentSkillGraphScene from './scenes/StudentSkillGraphScene';
import FilterWidget from '../../components/FilterWidget.vue';
import { LearningObjectiveStatus } from './scenes/TaskCard';
import IconComponent from '../../components/icon/IconComponent.vue';
import SkillRecommendationCard from '../../components/SkillRecommendationCard.vue';
import TrainingToolDropDown from '../../components/TrainingToolDropDown.vue';
import LearningObjectiveTabCard from '../../components/LearningObjectiveTabCard.vue';
import { debounce } from 'lodash';

import Icon from '../../components/icon/Icon';
import { GridElement } from '../../models/GridElement';


export default _defineComponent({
  expose: [],
  setup(__props) {

class SkillGraph extends Phaser.Game {
  constructor(config: Types.Core.GameConfig) {
    super(config);
  }
}
Icon.DOCUMENT;

const sideBarIsOpen = ref(true);
const handleSidebarFlyoutClick = () => {
  sideBarIsOpen.value = !sideBarIsOpen.value;
};
const selectedLearningObjectiveFilter = ref<LearningObjectiveStatus | null>(
  null
);

const handleFilterClick = (filterOption: LearningObjectiveStatus) => {
  selectedLearningObjectiveFilter.value = filterOption;
};

const gridData = ref([] as GridElement[]);

let game: Phaser.Game;
const wrapper = ref<HTMLElement>();

function createGame() {
  const skillGraphScene = new StudentSkillGraphScene(
    {
      fetchFilterValue: () => {
        return selectedLearningObjectiveFilter.value;
      },
      value: selectedLearningObjectiveFilter.value
    },
    () => {
      gridData.value = skillGraphScene.formGridData();
    }
  );
  const config: Types.Core.GameConfig = {
    type: Phaser.AUTO,
    dom: {
      createContainer: true
    },
    title: 'Matrix',
    width: CANVAS.defaults.width,
    height: CANVAS.defaults.height,
    parent: 'game',
    scene: [() => skillGraphScene],
    physics: {
      default: 'arcade',
      arcade: {
        debug: true
      }
    },
    backgroundColor: colors.cssExtraDarkGray
  };
  if (wrapper.value) {
    const rect = wrapper?.value.getBoundingClientRect();
    config.width = rect.width;
    config.height = rect.height;
  }
  game = new SkillGraph(config);
}

function destroyGame() {
  game.destroy(true);
}

function onResize() {
  destroyGame();
  createGame();
}

onMounted(() => {
  const debouncedOnResize = debounce(onResize, 300);
  window.addEventListener('resize', debouncedOnResize);
  createGame();
});

onUnmounted(() => {
  game.destroy(true);
  window.removeEventListener('resize', onResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(IconComponent, {
              icon: 
                sideBarIsOpen.value
                  ? _unref(Icon).DOUBLE_CHEVRON_LEFT
                  : _unref(Icon).DOUBLE_CHEVRON_RIGHT
              ,
              class: "w-4 h-4 cursor-pointer",
              onClick: handleSidebarFlyoutClick
            }, null, 8, ["icon"])
          ])
        ]),
        _createVNode(_Transition, null, {
          default: _withId(() => [
            (sideBarIsOpen.value)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(LearningObjectiveTabCard, {
                    title: "01 Mission Planning",
                    progress: "6",
                    active: true
                  }),
                  _createVNode(LearningObjectiveTabCard, {
                    title: "02 Ground Ops",
                    progress: "4",
                    active: false
                  }),
                  _createVNode(LearningObjectiveTabCard, {
                    title: "03 Flight Ops",
                    progress: "9",
                    active: false
                  }),
                  _createVNode(LearningObjectiveTabCard, {
                    title: "04 Post Flight Reqs",
                    progress: "6",
                    active: false
                  }),
                  _createVNode(LearningObjectiveTabCard, {
                    title: "05 EPs and Abnormal Ops",
                    progress: "5",
                    active: false
                  }),
                  _createVNode(LearningObjectiveTabCard, {
                    title: "06 Systems Operations",
                    progress: "8",
                    active: false
                  }),
                  _createVNode(LearningObjectiveTabCard, {
                    title: "07 Formation",
                    progress: "8",
                    active: false
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(FilterWidget, {
          options: _unref(statusFilterOptions),
          gridData: gridData.value,
          onFilterSelected: handleFilterClick
        }, null, 8, ["options", "gridData"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(SkillRecommendationCard, {
            icon: _unref(Icon).BOOK_INFO,
            label: "Review aircraft 3-1 relevant chapters"
          }, null, 8, ["icon"]),
          _createVNode(SkillRecommendationCard, {
            icon: _unref(Icon).FUNCTION,
            label: "Reacomplish aircraft weight and balance CBT"
          }, null, 8, ["icon"]),
          _createVNode(SkillRecommendationCard, {
            icon: _unref(Icon).PEOPLE_STAR,
            label: "Instructor-led ground training regarding flight plan preparation"
          }, null, 8, ["icon"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode(IconComponent, {
                  icon: _unref(Icon).DOUBLE_CHEVRON_DOWN,
                  class: "w-4 h-4"
                }, null, 8, ["icon"])
              ]),
              _hoisted_16
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(IconComponent, {
                  icon: _unref(Icon).DOUBLE_CHEVRON_UP,
                  class: "w-4 h-4"
                }, null, 8, ["icon"])
              ]),
              _hoisted_19
            ])
          ]),
          _hoisted_20,
          _createVNode("div", _hoisted_21, [
            _createVNode(TrainingToolDropDown, { label: "Book Knowledge" }),
            _createVNode(TrainingToolDropDown, { label: "Videos / goggles" }),
            _createVNode(TrainingToolDropDown, { label: "Formative exercises" }),
            _createVNode(TrainingToolDropDown, { label: "Exercises" }),
            _createVNode(TrainingToolDropDown, { label: "Chairflying" }),
            _createVNode(TrainingToolDropDown, { label: "Part - task ITD" }),
            _createVNode(TrainingToolDropDown, { label: "Part - task ITD" }),
            _createVNode(TrainingToolDropDown, { label: "Mission Rehearsal ITD" }),
            _createVNode(TrainingToolDropDown, { label: "Task Management ITD" }),
            _createVNode(TrainingToolDropDown, { label: "ATD" }),
            _createVNode(TrainingToolDropDown, { label: "Aircraft" })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", {
          ref: wrapper,
          class: "w-full h-full"
        }, [
          _hoisted_23
        ], 512)
      ])
    ])
  ]))
}
}

})